import { render, staticRenderFns } from "./interActor-card.vue?vue&type=template&id=707fd176&scoped=true&"
import script from "./interActor-card.vue?vue&type=script&lang=js&"
export * from "./interActor-card.vue?vue&type=script&lang=js&"
import style0 from "./interActor-card.vue?vue&type=style&index=0&id=707fd176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707fd176",
  null
  
)

export default component.exports